import React from 'react';
import Icon from '../../../components/AppIcon';

const SpecificationsPanel = ({ specifications }) => {
  return (
    <div className="p-6 md:p-8 rounded-xl bg-card border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 border border-primary/30 flex items-center justify-center">
          <Icon name="FileText" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground">
          Technical Specifications
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {specifications?.map((spec, index) => (
          <div
            key={index}
            className="p-4 rounded-lg bg-muted/50 border border-border space-y-2"
          >
            <div className="flex items-center gap-2">
              <Icon name={spec?.icon} size={16} color="var(--color-primary)" />
              <span className="text-sm font-medium text-muted-foreground caption">
                {spec?.label}
              </span>
            </div>
            <p className="text-base md:text-lg font-semibold text-foreground">
              {spec?.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecificationsPanel;